import React from 'react';
import 'antd/dist/antd.css'; 
import '../App.css';
import { CheckCircleTwoTone } from '@ant-design/icons';

import axios from 'axios';
import {Helmet} from "react-helmet";
// let parrafo1 = "¡Hemos recibido su pago!";
// let parrafo2 = "Felicitaciones! acabamos de enviarle un correo electronico con el informe!";
// let parrafo3 = "Muchas gracias!";

export default class InformeEnviado extends React.Component {
    state = {
        parrafos:{}
    }
    
    componentDidMount() {
        const baseUrl = "https://a3l.com.ar/Cotizador/Backend/DatosPagina/PAGINA_EXITO";
        axios.get(baseUrl)
        .then(res => {
            const parrafos = res.data;
            this.setState({ parrafos });
        })
    }
    
    render() {    
    return (
       
        <div className="body2">
        <div className="containerPrincipal">
            <div className="containerSecundario">
                <CheckCircleTwoTone twoToneColor="#52c41a" style={{fontSize:"70px"}} /> <br/><br/>
                <h1 className='bold'> { this.state.parrafos.parrafo1}</h1><br/>
                <h2 className='lighter'> { this.state.parrafos.parrafo2}</h2><br/>
                <br/><h2 className='lighter'>{ this.state.parrafos.parrafo3}</h2><br/><br/><br/>
            </div>

        </div>
            <Helmet>
              <script src="iframeResizer.contentWindow.min.js" type="text/javascript" />
            </Helmet>        
        </div>
     
    )
    }
}

// export default InformeEnviado




